export default __webpack_public_path__ + "static/contactUs-2dd663ab1cfb893b7b5b924ccb75997b.jpg";